<template>
  <v-footer
    :class="{ 'footer-lg-extra-space': userSignedIn }"
    :dark="$vuetify.theme.dark"
    :inset="true"
    class="font-weight-medium shadow-md white--text"
    color="#24073D"
    flat
    tile
  >
    <v-col class="footer-wrapper" cols="12">
      <div class="footer-menu">
        <v-btn
          v-for="(item, index) in footerItems"
          :key="index"
          :data-test-id="item.testId"
          :to="item.link"
          class="footer-link"
          elevation="0"
        >
          {{ item.label }}
        </v-btn>
      </div>
      <div class="social-menu d-flex flex-row flex-wrap justify-center align-center">
        <div
          v-for="(item, index) in socialItems"
          :key="index"
          :data-test-id="item.testId"
          class="footer-social-btn"
          @click="openLinkInNewTab(item.link)"
        >
          <component :is="item.icon" />
        </div>
      </div>
      <div class="footer-divider" />
      <div class="footer-copyright pb-6" data-test-id="all-rights-reserved">
        © {{ new Date().getFullYear() }} MAXQUEST. ALL RIGHTS RESERVED.
      </div>
    </v-col>
  </v-footer>
</template>

<script>
  import { mapGetters } from 'vuex';
  import IconFacebook from '@/assets/images/svg/icons/mq-social-fb.svg';
  import IconX from '@/assets/images/svg/icons/mq-social-x.svg';
  import IconInstagram from '@/assets/images/svg/icons/mq-social-insta.svg';
  import IconYoutube from '@/assets/images/svg/icons/mq-social-yt.svg';
  import IconTelegram from '@/assets/images/svg/icons/mq-social-tg.svg';
  import IconDiscord from '@/assets/images/svg/icons/mq-social-discord.svg';
  import socials from '@/data/socials';

  export default {
    name: 'VerticalFooter',

    components: {
      IconFacebook,
      IconX,
      IconInstagram,
      IconYoutube,
      IconTelegram,
      IconDiscord,
    },

    data: () => ({
      footerItems: [
        { label: 'Help Center', link: '/helpcenter', testId: 'help-center' },
        { label: 'Contact us', link: '/contact', testId: 'contact-us' },
        { label: 'About', link: '/about', testId: 'about' },
        { label: 'Terms & Conditions', link: '/tnc', testId: 'terms-conditions' },
        { label: 'Privacy Policy', link: '/privacypolicy', testId: 'privacy-policy' },
        { label: 'Crypto', link: '/crypto', testId: 'crypto' },
        { label: 'Responsible Gaming', link: '/responsible-gaming', testId: 'responsible-gaming' },
      ],
      socialItems: [
        { label: 'Facebook', link: socials.facebookUrl, icon: IconFacebook, testId: 'facebook-link' },
        { label: 'X.com', link: socials.twitterUrl, icon: IconX, testId: 'x-link' },
        { label: 'Instagram', link: socials.instagramUrl, icon: IconInstagram, testId: 'instagram-link' },
        { label: 'youtube', link: socials.youtubeUrl, icon: IconYoutube, testId: 'youtube-link' },
        { label: 'telegram', link: socials.telegramUrl, icon: IconTelegram, testId: 'telegram-link' },
        { label: 'discord', link: socials.discordUrl, icon: IconDiscord, testId: 'discord-link' },
      ],
    }),

    computed: {
      ...mapGetters(['getThemeMode']),

      userSignedIn() {
        return !!this.$store.state.user;
      },
    },

    methods: {
      openLinkInNewTab(url) {
        window.open(url, '_blank');
      },
    },
  };
</script>

<style lang="scss">
  .v-footer,
  .footer-wrapper {
    padding: 0;
  }

  .footer-wrapper {
    container: footer-wrapper / inline-size;
  }

  .footer-copyright {
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: 'Barlow', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 100%;

    &-info {
      margin-top: 12px;
      padding-inline: 12px;
      font-size: 11px;
    }
  }

  .v-application .black {
    background-color: #191919 !important;
  }

  .footer-link {
    color: #fff !important;
    transition: all 400ms ease;
    background-color: transparent !important;
    height: auto !important;
    min-width: auto !important;
  }

  .footer-link span {
    transition: all 400ms ease;
    border-bottom: 1px solid #fff;
  }

  .footer-link:hover span {
    color: #f8bf1e;
    background-color: transparent !important;
  }

  .footer-link .v-btn__content {
    color: #fff;
    font-family: 'Barlow', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 100%;
    border: 0;
    text-transform: none;
    text-decoration: none;
  }

  .footer-link .v-ripple__container {
    display: none;
  }

  .v-btn:hover::before {
    opacity: 0 !important;
  }

  .v-btn--active::before {
    opacity: 0 !important;
  }

  .social-menu {
    gap: 16px;
    margin: 24px 0;
  }

  .footer-divider {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.3);
    margin-bottom: 36px;
  }

  .footer-social-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      width: 40px;
      height: 40px;
    }
  }

  @media only screen and (max-width: 743px) {
    .footer-lg-extra-space {
      padding-bottom: 160px !important;
    }

    .v-footer {
      padding-bottom: 120px;
    }

    .footer-link .v-btn__content {
      border: none !important;
      background-color: transparent;
    }
  }

  @media only screen and (min-width: 744px) {
    .v-footer {
      padding-bottom: 100px;
    }
  }

  @media only screen and (min-width: 768px) {
    .v-footer {
      padding-bottom: 20px;
    }
  }

  @container footer-wrapper (min-width: 0px) {
    .footer-menu {
      line-height: 30px;
      padding-top: 32px;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }

  @container footer-wrapper (min-width: 1040px) {
    .footer-menu {
      flex-direction: row;
      justify-content: center;
      gap: 0;
      padding-top: 46px;
    }

    .social-menu {
      margin: 36px 0;
    }

    .footer-copyright {
      font-size: 16px;

      &-info {
        font-size: 14px;
      }
    }
  }

  @container footer-wrapper (min-width: 904px) {
    .footer-menu {
      flex-direction: row;
      justify-content: center;
      gap: 0;
    }

    .footer-link .v-btn__content {
      font-size: 16px;
    }
  }

  @container footer-wrapper (min-width: 1080px) {
    .footer-link .v-btn__content {
      font-size: 18px;
    }
  }

  @container footer-wrapper (min-width: 1178px) {
    .footer-menu {
      gap: clamp(16px, 2.35cqi, 36px);
    }
  }
</style>
